import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FormattedMessage } from "react-intl";
import DadosTransacoes from "./DadosTransacoes";

const ModalTransfer = ({
  handleCloseWithTransaction,
  dadosTransferencia = null,
}) => {
  const showModal = (content) => {
    setModalContent(content);
    setModalVisible(true);
  };

  return (
    <>
      <View style={styles.container}>
        <Text style={styles.text}>
          <FormattedMessage id="modalTransfer.transferenciaRealizadaCom" />{" "}
          <Text style={styles.success}>
            <FormattedMessage id="modalTransfer.transferenciaRealizadaComSucesso" />
          </Text>
          {/* {"\n\n"}O código desta transação é{" "}
              <Text style={styles.success}>txId{uuidv4.generate()}</Text> */}
        </Text>
        <DadosTransacoes dadosTransferencia={dadosTransferencia} />
        <TouchableOpacity
          onPress={() => {
            handleCloseWithTransaction();
          }}
        >
          <Text style={styles.btn}>
            <FormattedMessage id="modalTransfer.verComprovante" />
          </Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 350,
    alignSelf: "center",
    alignItems: "center",
    padding: 12,
    marginTop: 80,
    borderRadius: 8,
    borderColor: "#077A97",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },

  text: {
    fontSize: 16,
    marginTop: 30,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#077A97",
    fontWeight: "bold",
  },
  success: {
    fontWeight: "bold",
    color: "#077A97",
  },

  btn: {
    textTransform: "uppercase",
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
    textAlign: "center",
  },
});

export default ModalTransfer;
